import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { subscribe, errorText } from "@/lib/api";

const STEPS = ["one recurring meal", "one care exchange", "one shared resource", "one honest check-in"];

const JoinForm = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await subscribe(email);
      setDone(true);
      toast.success(data.already ? "You're already on the list." : "You're on the list. Welcome in.");
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  if (done)
    return (
      <div className="min-w-0 bg-sand p-8 border-4 border-ink" data-testid="join-success">
        <p className="font-mono fr-lbl">Saved</p>
        <h2 className="font-mono font-bold fr-h2 mt-2">You're on the list.</h2>
        <p className="mt-4 text-[17px] leading-[1.6]">Your free practice is ready now, and a welcome email with the link is on its way to <b>{email}</b>. The early chapter preview (spring 2027) and launch news will follow.</p>
        <Link to="/practice" className="fr-btn mt-6 w-full py-4 inline-flex justify-center" data-testid="join-open-practice-button">Open your free practice</Link>
      </div>
    );

  return (
    <form onSubmit={onSubmit} className="min-w-0 bg-sand p-8 border-4 border-ink shadow-[10px_10px_0_0_#1b1408]" data-testid="join-form">
      <h2 className="font-mono font-bold fr-h2">Join the reader list</h2>
      <p className="mt-4 text-[17px]">Get the free practice right away, plus an early chapter preview in spring 2027 and launch news.</p>
      <label htmlFor="join-email" className="font-mono fr-lbl block mt-6">Email</label>
      <input id="join-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="fr-field bg-white" data-testid="join-email-input" />
      <button type="submit" disabled={busy} className="fr-btn mt-6 w-full py-4" data-testid="join-submit-button">
        {busy ? "Saving…" : "Count me in"}
      </button>
    </form>
  );
};

export const Join = () => (
  <section id="join" className="bg-rose text-ink py-24 md:py-32" data-testid="join-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
      <div className="min-w-0 fr-reveal">
        <p className="font-mono fr-lbl">Free practice / 90 days</p>
        <ul className="font-mono mt-6 space-y-4 text-xl md:text-2xl font-bold" data-testid="join-practice-list">
          {STEPS.map((s, i) => (
            <li key={s} className="transition-transform duration-200 hover:translate-x-2">[{i + 1}] {s}</li>
          ))}
        </ul>
        <p className="mt-6 text-[17px]">before making large housing commitments.</p>
      </div>
      <JoinForm />
    </div>
  </section>
);
